import {Component, DestroyRef, inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {GetAllCampaignGroupPayloadModel} from '../campaign-groups/campaign_groups_interfaces';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {Router} from '@angular/router';
import {
  CurrentAdgroupSelectService,
  CurrentCampaignGroupSelectService,
  CurrentCampaignGroupSequenceSelectService, CurrentCampaignSelectService,
  CurrentCrudSelectBehaviorServiceAsString,
  CurrentSelectedSlugBehaviorService
} from '../objectPassingService';
import {MatDialog} from '@angular/material/dialog';
import {CampaignGroupSequenceService} from './campaign-group-sequence.service';
import {GetAllCampaignGroupSequencePayloadModel} from './campaign_group_sequence_interfaces';
import {CreateCampaignGroupInitPayload} from '../campaign-groups/campaign-groups.component';
import {MatProgressBar} from '@angular/material/progress-bar';
import { NgClass } from '@angular/common';
import {MatDivider} from '@angular/material/divider';
import {MatList, MatListItem} from '@angular/material/list';
import {MatCard} from '@angular/material/card';
import {MatFabButton, MatIconButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {MatTooltip} from '@angular/material/tooltip';






export interface CreateCampaignGroupSequenceInitPayload {
  is_edit: false;
}


@Component({
  selector: 'app-campaign-group-sequence',
  imports: [
    MatProgressBar,
    MatDivider,
    MatList,
    MatListItem,
    NgClass,
    MatCard,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatFabButton,
    MatFormField,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatPaginator,
    MatRadioButton,
    MatRadioGroup,
    MatRow,
    MatRowDef,
    MatSort,
    MatSortHeader,
    MatTable,
    MatTooltip,
    MatHeaderCellDef
],
  providers: [

  ],
  templateUrl: './campaign-group-sequence.component.html',
  styleUrl: './campaign-group-sequence.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class CampaignGroupSequenceComponent implements OnInit {


  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  is_loading = true;
  selectedRowIndex: number | null = null;
  client_id: number = 0
  client_slug: string = '';



  dataSource!: MatTableDataSource<GetAllCampaignGroupPayloadModel>;
  displayedColumns: string[] = ['campaign_group_sequence_id', 'name', 'status', 'View', 'Edit', 'Delete'];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;





  constructor(
    public router: Router, //all components need this
    private currentSelectedSlugBehaviorService: CurrentSelectedSlugBehaviorService,
    public dialog: MatDialog,
    private currentCrudSelectBehaviorServiceAsString: CurrentCrudSelectBehaviorServiceAsString,
    private campaignGroupSequenceService: CampaignGroupSequenceService,
    private currentCampaignGroupSequenceSelectService: CurrentCampaignGroupSequenceSelectService,
    private currentCampaignGroupSelectService: CurrentCampaignGroupSelectService,
    private currentCampaignSelectService: CurrentCampaignSelectService,
    private currentAdgroupSelectService: CurrentAdgroupSelectService,

  ) { }


  ngOnInit() {

    localStorage.removeItem('campaign_group_sequence_id');
    localStorage.removeItem('campaign_group_id');
    localStorage.removeItem('campaign_id');
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');


    this.currentCampaignGroupSequenceSelectService.announceCampaignGroupSequenceSelect('')
    this.currentCampaignGroupSelectService.announceCampaignGroupSelect('')
    this.currentCampaignSelectService.announceCampaignSelect('')
    this.currentAdgroupSelectService.announceAdgroupSelect('')

    this.client_id = parseInt(localStorage.getItem('client_id') || '0', 10);
    this.client_slug = localStorage.getItem('client_slug') || '';


    this.getData(false)

  } //end ngOnInit

  getData(is_mocked:boolean = false) {

    this.is_loading = true;
    const show_deleted = 'false'
    console.log('WTF is_mocked', is_mocked);
    console.log('WTF this.is_loading', this.is_loading);


    this.campaignGroupSequenceService.gets(`adserver/campaign_group_sequences/${this.client_id}`, is_mocked).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {


        console.log('WOWEEEEEE!!!',data)

        const jsonString = JSON.stringify(data);
        localStorage.setItem('campaign_group_sequence_list', jsonString);

        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.is_loading = false;



      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
      }
    ) //end subscribe

  } //end getData


  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  addCampaignGroupSequence(is_edit: boolean, row?: GetAllCampaignGroupSequencePayloadModel): void {

    // localStorage.removeItem('campaigngroupsaved');
    // localStorage.removeItem('campaignsaved');
    // localStorage.removeItem('adgroupsaved');
    // localStorage.removeItem('adsaved');
    if (is_edit && row) {
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(row));
    } else {
      const payload: CreateCampaignGroupSequenceInitPayload = { is_edit: false };
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(payload));
    }
    // Ensure subscribers are ready before navigation
    // It’s faster and cleaner than setTimeout(..., 0).
    queueMicrotask(() => {
      this.router.navigate(
        ['/nav-campaigns', { outlets: { admeta: ['campaign-group-sequence-meta'] } }]
      ).then(() => console.log('Redirected to campaign-groups-meta'));
    });
  }

  getTableRecord(row: object) {
  } // end getTableRecord

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  deleteRow(row: GetAllCampaignGroupSequencePayloadModel){
    console.log('deleteRow', row);
    let campaign_group_sequence_id = row.campaign_group_sequence_id;
    this.campaignGroupSequenceService.delete(`adserver/campaign_group_sequence/${campaign_group_sequence_id}`).pipe(takeUntil(this.destroyed)).subscribe(x => {
      console.log(x);
      this.getData(false);
    }, error => {
      console.log('error',error)
    });



  } //end deleteRow

  viewData(row: GetAllCampaignGroupSequencePayloadModel) {
    console.log('viewData', row);
    const campaign_group_sequence_id = row['campaign_group_sequence_id']
    localStorage.setItem('campaign_group_sequence_id', campaign_group_sequence_id);
    localStorage.removeItem('campaign_group_id');
    localStorage.removeItem('campaign_id');
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');


    localStorage.removeItem('adgroup_name');
    this.currentAdgroupSelectService.announceAdgroupSelect('');
    localStorage.removeItem('campaign_name');
    this.currentCampaignSelectService.announceCampaignSelect('');
    localStorage.removeItem('campaign_group_name');
    this.currentCampaignGroupSelectService.announceCampaignGroupSelect('');


    localStorage.setItem('campaign_group_sequence_name', row.name);
    this.currentCampaignGroupSequenceSelectService.announceCampaignGroupSequenceSelect(row.name);
    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['campaign-groups'] } }]).then(r => console.log('redirect to campaigns'));
  } //end viewData(row)








} //end CampaignGroupSequenceComponent
